<script setup lang="ts">
import type { NodeActivity } from '@/types'

defineProps<{ activity: NodeActivity }>()

const NODE_LABELS: Record<string, string> = {
  query_prep:         'Query Prep',
  tool_registry:      'Tool Registry',
  tag_extraction:     'Tag Extraction',
  resolver:           'Entity Resolver',
  router:             'Router',
  probe_executor:     'Probe',
  retrieval_planner:  'Retrieval Planner',
  parallel_retriever: 'Parallel Retriever',
  evidence_processor: 'Evidence Processor',
  composer:           'Composer',
}

const STATUS_STYLES: Record<NodeActivity['status'], string> = {
  running:  'border-indigo-500 text-indigo-700 bg-indigo-50',
  complete: 'border-neutral-300 text-neutral-500 bg-neutral-50',
  error:    'border-red-500 text-red-700 bg-red-50',
}

const DOT_COLORS: Record<NodeActivity['status'], string> = {
  running:  'bg-indigo-500',
  complete: 'bg-green-500',
  error:    'bg-red-500',
}
</script>

<template>
  <div
    class="text-xs px-3 py-1.5 rounded-md my-0.5 max-w-[85%] self-start border-l-[3px] transition-colors flex items-start gap-1.5"
    :class="STATUS_STYLES[activity.status]"
  >
    <span
      v-if="activity.status === 'running'"
      class="inline-block w-1.5 h-1.5 rounded-full mt-[3px] shrink-0 animate-pulse-dot"
      :class="DOT_COLORS[activity.status]"
    />
    <span v-else-if="activity.status === 'complete'" class="shrink-0 mt-px">&#10003;</span>
    <span v-else class="shrink-0 mt-px">&#10007;</span>

    <span>
      <strong class="font-medium">{{ NODE_LABELS[activity.node] || activity.node }}</strong>
      &mdash; {{ activity.detail }}
    </span>
  </div>
</template>
